import request from "@/utils/request";

//获取token
export function getweChatToken(){
  return request({
    url: '/wms/ecustom/getAccessToken',
    method: 'get'
  })
}
//注册
export function getQrCode(register) {
  return request({
    url: 'wms/ecustom/getQrCode',
    method: 'post',
    data: register
  })
}
//查询是否注册
export function getsendIdSuccess(sendId) {
  return request({
    url: 'wms/ecustom/getsendIdSuccess?sendId='+sendId,
    method: 'get',
  })
}
//查询
  export function queryWmOrderAppointment(orderNoParam) {
    return request({
      url: '/wms/ecustom/queryWmOrderAppointment',
      method: 'post',
      data: orderNoParam
    })
  }
//http://172.16.8.107:8080/api/cts-wms-service/wms/ecustom/queryWmOrderAppointment

//提交
export function submitAppointment(data) {
  return request({
    url: '/wms/ecustom/submitAppointment',
    method: 'post',
    data
  })
}

//查询
export function queryWmOrderGoods(orderNoParam) {
  return request({
    url: '/wms/ecustom/queryWmOrderGoods',
    method: 'post',
    data: orderNoParam
  })
}
//结算费用计算

export function calculationOfCharges(params) {
  return request({
    url: '/wms/ecustom/calculationOfCharges',
    method: 'post',
    data: params
  })
}

//提交
export function submitPickUpGoods(wmAppApmtListDto) {
  return request({
    url: '/wms/ecustom/submitPickUpGoods',
    method: 'post',
    data: wmAppApmtListDto
  })
}

export function mainSingleInformation(data){
  return request({
    // url: '/ilporder/queryForWeb',
    url: '/web/queryMainSystem/queryForWeb',
    method: 'post',
    data
  })
}

export function queryFreight(data){
  return request({
    url: '/cts-core/queryFreightForWeb',
    method: 'post',
    data
  })
}

export function getWmOrderPhotos(data) {
  return request({
    url: '/wms/ecustom/getWmOrderPhotos',
    method: 'post',
    data
  })
}

export function queryMfiLForWeb(data) {
  return request({
    url: '/ilporder/queryMfiLForWeb',
    method: 'post',
    data
  })
}

export function download(url,data) {
  return request({
    url: url,
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Accept': 'text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,image/apng,*/*;q=0.8,application/signed-exchange;v=b3;q=0.9'
    },
    responseType: 'blob'
  })
}

export function predictFreight(data) {
  return request({
    url: '/cts-core/predictFreight',
    method: 'post',
    data,
  })
}
